import React from 'react';
import CloseIcon from 'components/icon/close-icon';
import SquareCloseIcon from 'components/icon/square/close-icon';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';

export type CloseButtonProps = {
  onClose: () => void;
  testId: string;
};

export const ExpCloseButton: React.FC<CloseButtonProps> = ({ onClose, testId }) => (
  <div className={styles['close-container']} onClick={onClose}>
    <CloseIcon
      className={styles['close-icon']}
      testId={`${testId}${testIds.closeButton}`}
    />
  </div>
);

export const DefaultCloseButton: React.FC<CloseButtonProps> = ({ onClose, testId }) => (
  <div className={styles['close-container']}>
    <SquareCloseIcon
      onClick={onClose}
      isHoverable
      testId={`${testId}${testIds.closeButton}`}
      bgColor={'light'}
    />
  </div>
);